import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 120000 });

export function getToken() {
  return localStorage.getItem("compasso_token");
}
export function setToken(t) {
  if (t) localStorage.setItem("compasso_token", t);
  else localStorage.removeItem("compasso_token");
}

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 402) {
      window.dispatchEvent(new CustomEvent("premium-required", { detail: err.response.data?.detail }));
    }
    if (err.response && err.response.status === 401) {
      setToken(null);
      if (!window.location.pathname.includes("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function fileUrl(fileId) {
  return `${API}/files/${fileId}/download?auth=${getToken()}`;
}

export function apiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
